'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _paymentHistory = require('../payment-history');

var _paymentHistory2 = _interopRequireDefault(_paymentHistory);

var _dateUtils = require('../common/utils/date-utils');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _registrations = require('ifeis-isomorphic/lib/redux/actions/registrations');

var _getFeatureFlags = require('ifeis-isomorphic/lib/redux/actions/feature-flags/getFeatureFlags');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * FeisListController directive
 *
 * Public attributes:
 *
 * hide-public              - will display only user's attached feiseanna
 * list-only="active"       - will display only future feiseanna
 * list-only="completed"    - will display only past feiseanna
 * all-feiseanna            - to pass all feiseanna list from parent scope to avoid multiple requests
 *
 * Please note that this directive should be wrapped with 'ng-if=ctrl.feiseanna'
 * to wait until all feiseanna promise in parent controller is resolved.
 */

var FeisListController = function () {
  function FeisListController($scope, $state, $mdDialog, $attrs, $filter, $ngRedux, fFeisService, fAccountService, fSession, fPaymentHistoryDialog, msgService, fEventParticipantsModal) {
    var _this = this;

    _classCallCheck(this, FeisListController);

    this.searchFilter = function (feis) {
      return _this.search ? feis.feis.name.toLowerCase().indexOf(_this.search.toLowerCase()) >= 0 : feis;
    };

    this._ = {
      $scope: $scope,
      $state: $state,
      $mdDialog: $mdDialog,
      $filter: $filter,
      $ngRedux: $ngRedux,
      fFeisService: fFeisService,
      fAccountService: fAccountService,
      fPaymentHistoryDialog: fPaymentHistoryDialog,
      msgService: msgService,
      fEventParticipantsModal: fEventParticipantsModal
    };

    this.fSession = fSession;
    this.showMore = false;
    this.mineFilter = angular.isDefined($attrs.hidePublic) ? 'mine' : 'all';
    var statusFilter = angular.isDefined($attrs.listOnly) ? $attrs.listOnly : false;
    var fullDay = 86400000; // 24 hours
    var isLoggedIn = this.fSession.isLoggedIn();

    if (isLoggedIn) {
      this.fSession.user().then(function (user) {
        _this.user = user;

        $ngRedux.dispatch((0, _getFeatureFlags.getFeatureFlags)()).then(function (response) {
          _this.isCrossNavigationEnabled = !!(response.payload && response.payload.flags.isCrossNavigationEnabled);
          if (_this.isCrossNavigationEnabled && (window.location.href.endsWith('feiseanna') || window.location.href.endsWith('feiseanna/completed'))) {
            _this.goToExternalUrl('feiseanna-list');
          }
        });

        $ngRedux.connect((0, _mapStateToController2.default)(_this.allFeiseanna, user.id, _this.mineFilter, statusFilter))(_this);

        // For MY active feiseanna on the Dashboard page
        // display a list of registrations for my dependents
        if (_this.mineFilter === 'mine' && statusFilter === 'active') {
          _this.allFeiseanna.filter(function (f) {
            return f.feis.dt_end + fullDay > _this.now && f.feis.status !== 'FINAL';
          }).forEach(function (f) {
            if (f.registered && f.registered > 0) {
              _this._.$ngRedux.dispatch((0, _accounts.getMyCompetitorsForFeis)(f.feis_id, _this.user.id)).then(function (deps) {
                deps.payload.forEach(function (d) {
                  return _this._.$ngRedux.dispatch((0, _registrations.getRegistrations)(f.feis_id, d.id));
                });
              });
            }
          });
        }
      });
    } else {
      $ngRedux.connect((0, _mapStateToController2.default)(this.allFeiseanna, undefined, this.mineFilter, statusFilter))(this);
    }
  }

  //returns a boolean: whether or not to show the live stage schedule icon


  _createClass(FeisListController, [{
    key: 'showLiveScheduleIcon',
    value: function showLiveScheduleIcon(fdata) {

      //convert all of the dates to the correct timezone and subtract 2 days from
      //  the feis start so that we show the icon during the 2 days leading up to
      //  feis day
      var rangeStart = (0, _dateUtils.convertMsToDate)(fdata.feis.dt_start, fdata.feis.tz);
      rangeStart.setDate(rangeStart.getDate() - 2);
      var rangeEnd = (0, _dateUtils.convertMsToDate)(fdata.feis.dt_end, fdata.feis.tz);
      var tzNow = (0, _dateUtils.convertMsToDate)(this.now, fdata.feis.tz);

      // show the icon if the user is registered for the feis or has saved it, and
      // if the current date is during the feis' date range (inclusive)
      return (!!fdata.registered || !!fdata.saved) && tzNow >= rangeStart && tzNow <= rangeEnd;
    }
  }, {
    key: 'star',
    value: function star(fdata, $event) {
      var _this2 = this;

      if ($event) FeisListController.stopEvent($event);

      this._.$ngRedux.dispatch((0, _accounts.attachFeis)(this.user.id, fdata.feis.id)).then(function (res) {
        _this2.feiseanna.forEach(function (f) {
          if (f.feis.id === fdata.feis.id) f.saved = 1;
        });
      });
    }
  }, {
    key: 'unstar',
    value: function unstar(fdata, $event) {
      var _this3 = this;

      if ($event) FeisListController.stopEvent($event);

      if (fdata.registered == 1) {
        this._.$mdDialog.show(this._.$mdDialog.alert().clickOutsideToClose(true).title('Already registered').textContent('You can\'t unstar a feis you are currently registered with.').ok('Got it!').targetEvent($event));
      } else {
        this._.$ngRedux.dispatch((0, _accounts.detachFeis)(this.user.id, fdata.feis.id)).then(function () {
          _this3.feiseanna.forEach(function (f) {
            if (f.feis.id === fdata.feis.id) f.saved = 0;
          });
          if (_this3.mineFilter === 'mine') {
            _this3.feiseanna = _this3.feiseanna.filter(function (f) {
              return f.feis.id !== fdata.feis.id;
            });
          }
        });
      }
    }
  }, {
    key: 'go',
    value: function go(state, params, $event) {
      if ($event) FeisListController.stopEvent($event);
      this._.$state.go(state, params);
    }
  }, {
    key: 'goToExternalUrl',
    value: function goToExternalUrl(path, id, slug) {
      if (!path) return;
      var url = IFEIS_APPV2_URI + '/' + path;
      if (id && slug) {
        url = url + '/' + id + '/' + slug;
      }
      window.location.href = url;
    }
  }, {
    key: 'openPaymentsDialog',
    value: function openPaymentsDialog(ev, feis) {
      var _this4 = this;

      this._.fPaymentHistoryDialog(ev, this.user, feis).then(function () {}, function (err) {
        return _this4._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'shortlistedMessage',
    value: function shortlistedMessage() {
      return !this.showMore ? 'You see ' + this.shortlistedNum + ' of ' + this.feiseanna.length + ' feiseanna' : 'You see all ' + this.feiseanna.length + ' feiseanna';
    }

    // If a Search attribute being provided,
    // filter feiseanna by name

  }, {
    key: 'openFeisParticipantsModal',
    value: function openFeisParticipantsModal(e, feis, event) {
      if (e) FeisListController.stopEvent(e);
      this._.fEventParticipantsModal(e, feis, event);
    }
  }], [{
    key: 'stopEvent',
    value: function stopEvent($event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }]);

  return FeisListController;
}();

exports.default = angular.module('ifeis.feis-list', ['ngMaterial', 'ifeis.dashboard-event-modal']).directive('fFeisList', function () {
  return {
    controller: FeisListController,
    controllerAs: 'list',
    bindToController: true,
    template: require('./tpl.html'),
    restrict: 'E',
    scope: {
      allFeiseanna: "=",
      search: "="
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./feis-list/index.js
// module id = 209
// module chunks = 0